import { Controller } from "@hotwired/stimulus"

// Opens and closes a dropdown list of options

export default class extends Controller {
  static targets = [
    "option",
    "list",
    "combobox", // input field that will display the selected value and open the dropdown
    "selectInput", // hidden input field that will store the selected value
  ]

  refreshFromSelectInput() {
    const selectedOption = this.selectInputTarget.selectedOptions[0]
    if(selectedOption) {
      this.comboboxTarget.value = selectedOption.text
    }
  }

  open() {
    this.listTarget.setAttribute("aria-expanded", "true")

    if (!this.closeOnClickOutsideListener) {
      this.closeOnClickOutsideListener = this.#closeOnClickOutside.bind(this)
      window.addEventListener("click", this.closeOnClickOutsideListener)
    }

    this.dispatch("opened")
  }

  toggle() {
    this.isOpen ? this.close() : this.open()
  }

  selectActive() {
    const option = this.activeOption
    if (option) {
      this.#selectOption(option)
    }
  }

  select(event) {
    this.#selectOption(event.target.closest("[data-dropdown-target='option']"))
  }

  close() {
    this.listTarget.setAttribute("aria-expanded", "false")

    window.removeEventListener("click", this.closeOnClickOutsideListener)
    this.closeOnClickOutsideListener = null
  }

  clear() {
    this.comboboxTarget.value = ""
    this.selectInputTarget.value = ""
    this.dispatch("cleared")
  }

  get isOpen() {
    return this.listTarget.getAttribute("aria-expanded") === "true"
  }

  get activeOption() {
    return this.visibleOptions.find(
      (option) => option.dataset.active === "true"
    )
  }

  get visibleOptions() {
    return this.optionTargets.filter(
      (option) => option.classList.contains("tw:hidden") === false
    )
  }

  #selectOption(option) {
    this.comboboxTarget.value = option.dataset.label.trim()
    this.selectInputTarget.value = option.dataset.value
    this.close()

    this.dispatch("selected")
  }

  #closeOnClickOutside(event) {
    if (!this.listTarget.contains(event.target)) {
      this.close()
    }
  }
}
